import React, { useState } from "react";
import { reasons } from "../data/siteContent";

function ReasonItem({ answer, isActive, number, onClick, question }) {
  return (
    <div className={`faq-item ${isActive ? "faq-active" : ""}`}>
      <button type="button" className="faq-trigger" onClick={onClick}>
        <h3>
          <span>{number}</span> {question}
        </h3>
        <i className="faq-toggle bi bi-chevron-right"></i>
      </button>
      <div className="faq-content" aria-hidden={!isActive}>
        <p>{answer}</p>
      </div>
    </div>
  );
}

function WhyUs() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section id="why-us" className="section why-us light-background">
      <div className="container-fluid">
        <div className="row gy-4">
          <div className="col-lg-7 d-flex flex-column justify-content-center order-2 order-lg-1">
            <div className="content px-xl-5" data-aos="fade-up" data-aos-delay="100">
              <h3>
                <span>Why teams choose </span>
                <strong>Operating Software</strong>
              </h3>
              <p>
                We stay close to the business problem, communicate directly,
                and keep delivery practical from the first conversation to the
                final handoff.
              </p>
            </div>

            <div className="faq-container px-xl-5" data-aos="fade-up" data-aos-delay="200">
              {reasons.map((item, index) => (
                <ReasonItem
                  key={item.number}
                  answer={item.description}
                  isActive={activeIndex === index}
                  number={item.number}
                  onClick={() => handleClick(index)}
                  question={item.title}
                />
              ))}
            </div>
          </div>

          <div className="col-lg-5 order-1 order-lg-2 why-us-img">
            <img
              src="assets/img/why-us.png"
              className="img-fluid"
              alt="Illustration representing collaboration"
              data-aos="zoom-in"
              data-aos-delay="100"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
